import { Button, Typography } from '@breetometer/components';

import type { IPrompt } from './Prompt.helpers';

export const Prompt = ({
	title,
	description,
	onCancel,
	onProceed,
	cancelBtnText,
	icon,
	proceedBtnText,
	isLoading,
	content,
}: IPrompt) => (
	<div
		className='prompt bg-primary-500'
		data-testid='prompt'
	>
		{icon}

		<div>
			<Typography
				as='h3'
				className='color-neutral-50'
			>
				{title}
			</Typography>

			<Typography className='color-primary-50'>{description}</Typography>

			{content && <div className='content'>{content}</div>}
		</div>

		<div className='prompt_cta'>
			{onCancel ? (
				<Button
					label={cancelBtnText ?? 'Cancel'}
					variant='outline'
					onClick={onCancel}
					className='bg-primary-500 border-dark-navy color-primary-50'
				/>
			) : null}

			<Button
				label={proceedBtnText ?? 'Proceed'}
				variant='danger'
				onClick={onProceed}
				isLoading={isLoading}
				className='bg-error-700 theme-border-none'
			/>
		</div>
	</div>
);
